module.exports = __webpack_public_path__ + "img/pic6.ce38a570.png";